<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->
<style lang="scss">
// .login-page-wrapper {
//   background: url(../../../assets/images/checkin-images/checkin-login-bg.jpg) no-repeat scroll center center / cover !important;
// }
.layout--full-page .full-page-bg-color {
    border-radius: 8px;
}
.full-page-bg-color .d-theme-dark-bg {
    border-radius: 8px;
}
.fill-current.w-10 {
  width: 13rem !important;
}
path#Ellipse_529_copy_3 {
  fill: #f00;
}
path#Ellipse_529_copy_2 {
  fill: #333;
}
path#Ellipse_529_copy_4 {
  fill: #333;
}
path#e2m_copy {
  fill: #333;
}
.con-ul-tabs{display: none;}
.cls-1 {
        fill: #18191a;
        fill-rule: evenodd;
      }

      .cls-2 {
        fill: #ea212d;
      }
</style>

<template>
  <div
    class="h-screen flex w-full bg-img login-page-wrapper checkin-wrapper vx-row no-gutter items-center justify-center"
    id="page-login" :style="{'background-image':'url(' + getCDNUrl( con.resourceBaseUrl + 'OA_UAT%2FDefaults%2Fimage%2Flogin-assets'+'%2F'+'login-background.png') +  ')'}"
  >

    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row no-gutter justify-center items-center">
            <div class="vx-col hidden lg:block lg:w-1/2">
              <img :src="getCDNUrl(con.resourceBaseUrl + 'OA_UAT%2FDefaults%2Fimage%2Flogin-assets%2Flogin-side-image.png')" alt="login" class="mx-auto login-left" />
            </div>

            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="px-8 pt-8 login-tabs-container checkin-login-tab">
                <div class="login-logo htx-logo mb-8">
                  <img :src="getCDNUrl(con.resourceBaseUrl + 'OA_UAT%2FDefaults%2Fimage%2Flogin-assets%2Flogo.png')" alt="login logo" style="max-width: 100%;height: auto;"/>
                </div>
                <div class="vx-card__title mb-4">
                  <h4>CMS login</h4>
                  <p>Welcome back, please login to your account.</p>
                </div>

                <vs-tabs>
                  <!--<vs-tab label="JWT">
                    <login-jwt></login-jwt>
                  </vs-tab>-->

                  <vs-tab label="">
                    <login-firebase></login-firebase>
                  </vs-tab>

                  <!--<vs-tab label="Auth0">
                    <login-auth0></login-auth0>
                  </vs-tab>-->
                </vs-tabs>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>


<script>
//import LoginJwt from "./LoginJWT.vue";
import LoginFirebase from "./LoginFirebase.vue";
//import LoginAuth0 from "./LoginAuth0.vue";
import con from "@/firebase/firebaseInit.ts";
import commonMixin from '@/mixins/common'

export default {
  mixins: [commonMixin],
  components: {
    //LoginJwt,
    LoginFirebase,
    //LoginAuth0
  },
  data() {
    return {
      con : con
    }
  }
};
</script>

<style lang="scss">
.login-tabs-container {
  min-height: 505px;

  .con-tab {
    padding-bottom: 14px;
  }

  .con-slot-tabs {
    margin-top: 1rem;
  }
}
</style>
